import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../i18n/FormattedMessage';

/**
 * AriesButton — base reusable button. Owns the shared markup/behavior and
 * applies the `aries-btn-{variant}` design-system primitive (single style
 * source). Prefer the thin variant wrappers (AriesPrimaryButton,
 * AriesSecondaryButton, AriesLinkButton) in views; add new variants by
 * composing this base without touching the existing ones.
 */
const AriesButton = ({
  variant,
  size,
  text,
  children,
  icon,
  iconRight,
  type,
  disabled,
  onClick,
  className,
  ...rest
}) => (
  <button
    type={type}
    disabled={disabled}
    onClick={onClick}
    className={`aries-btn aries-btn-${variant} ${
      size === 'sm' ? 'aries-btn-sm' : ''
    } ${className || ''}`}
    {...rest}
  >
    {icon && <span className="aries-btn-icon">{icon}</span>}
    {children ||
      (text ? <FormattedMessage id={text} defaultMessage={text} /> : null)}
    {iconRight && <span className="aries-btn-icon">{iconRight}</span>}
  </button>
);

AriesButton.propTypes = {
  variant: PropTypes.oneOf([
    'primary',
    'secondary',
    'link',
    'text-link',
    'outline-primary',
    'outline-link',
  ]),
  size: PropTypes.oneOf(['md', 'sm']),
  text: PropTypes.string,
  children: PropTypes.node,
  icon: PropTypes.node,
  iconRight: PropTypes.node,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

AriesButton.defaultProps = {
  variant: 'primary',
  size: 'md',
  text: undefined,
  children: null,
  icon: null,
  iconRight: null,
  type: 'button',
  disabled: false,
  onClick: () => {},
  className: '',
};

export default AriesButton;
